import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENDPOINTS } from '@core/constants/endpoints';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
    ReportNotificationsSubscription,
    UserReportSubscription,
} from '@app/shared/models/smart-report.model';
import { UserReportNotificationSubscriptionAdapter } from '@core/services/adapters/user-report-notification-subscription.adapter';
import { UserReportSubscriptionsAdapter } from '@core/services/adapters/user-report-subscriptions.adapter';

@Injectable()
export class UserNotificationService {
    constructor(
        private http: HttpClient,
        private reportNotificationSubscriptionAdapter: UserReportNotificationSubscriptionAdapter,
        private userReportSubscriptionsAdapter: UserReportSubscriptionsAdapter
    ) {}

    getReportsNotifications(
        userId: number,
        companyId: number
    ): Observable<ReportNotificationsSubscription> {
        return this.http
            .get(`${ENDPOINTS.apis.users.base}/${userId}/notifications/${companyId}/reports`)
            .pipe(map((data: any) => this.reportNotificationSubscriptionAdapter.adapt(data)));
    }

    getUserReportSubscriptions(userId: number): Observable<Array<UserReportSubscription>> {
        return this.http
            .get(`${ENDPOINTS.apis.users.base}/${userId}/notifications/reports`)
            .pipe(map((data: any) => this.userReportSubscriptionsAdapter.adapt(data)));
    }

    updateGlobalReportsSubscription(userId: number, companyId: number, subscribe: boolean) {
        const body = {
            globalReportsEmail: subscribe,
        };

        return this.http.put(
            `${ENDPOINTS.apis.users.base}/${userId}/notifications/${companyId}/globalreports`,
            body
        );
    }

    updateReportTypeSubscription(
        userId: number,
        companyId: number,
        reportTypeId: number,
        subscribe: boolean
    ) {
        const body = {
            globalTypeEmail: subscribe,
        };

        return this.http.put(
            `${ENDPOINTS.apis.users.base}/${userId}/notifications/${companyId}/reporttype/${reportTypeId}`,
            body
        );
    }

    updateReportConfigSubscription(
        userId: number,
        companyId: number,
        reportTypeId: number,
        configId: number,
        subscribe: boolean
    ): Observable<unknown> {
        const body = {
            typeId: reportTypeId,
        };

        if (subscribe) {
            return this.http.post(
                `${ENDPOINTS.apis.users.base}/${userId}/notifications/${companyId}/reportconfig/${configId}`,
                body
            );
        } else {
            return this.http
                .delete(
                    `${ENDPOINTS.apis.users.base}/${userId}/notifications/${companyId}/reportconfig/${configId}/reporttype/${reportTypeId}`,
                    {
                        responseType: 'text',
                    }
                )
                .pipe(map((response) => ({ succeed: response.toLowerCase() === 'ok' })));
        }
    }
}
